import React from "react";
import { ApexOptions } from "apexcharts";
import Chart from "react-apexcharts";
//import emptyPic from "../../../assets/images/empty-chart.jpg";

interface dataSet {
  name: string;
  data: number[];
}

interface Iprops {
  datasets: dataSet[];
  labels: string[];
  title: string;
  subtitle: string[];
  colors: string[];
  exportfilename: string;
}
// simple bar chart
const BarChart = (props: Iprops) => {
  // default options
  const { colors, datasets, labels, title, exportfilename, subtitle } = props;

  const apexBarChartOpts: ApexOptions = {
    chart: {
      height: 380,
      type: "bar",
      toolbar: {
        show: true,

        export: {
          csv: {
            filename: exportfilename,
          },
          png: {
            filename: exportfilename,
          },
          svg: {
            filename: exportfilename,
          },
        },
      },
    },
    title: {
      text: title,
      align: "center",
      margin: 18,
      offsetY: -8,
    },
    annotations: {
      texts: [
        {
          x: 30,
          y: 34,
          text: subtitle[0],
          fontSize: "12px",
          borderColor: "transparent",
          paddingTop: 3,
          paddingBottom: 2,
        },
        {
          x: 30,
          y: 52,
          text: subtitle[1],

          fontSize: "12px",
          borderColor: "transparent",
          paddingTop: 2,
          paddingBottom: 30,
        },
      ],
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
        columnWidth: "30%",
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: 0,
      style: {
        fontSize: "10px",
        colors: ["#000"],
      },
    },
    colors: colors,
    stroke: {
      show: true,
      width: 1,
      // colors: ["#fff"],
      curve: "smooth",
    },

    xaxis: {
      categories: labels,
    },
    legend: {
      showForSingleSeries: true,
      offsetY: -10,
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
    grid: {
      borderColor: "#f1f3fa",
      padding: {
        left: 0,
        right: 0,
      },
    },
  };

  // chart data
  // const apexBarChartData = [
  //     {
  //         name: 'Series 1',
  //         data: [44, 55, 41, 64, 22, 43, 21],
  //     },
  //     {
  //         name: 'Series 2',
  //         data: [53, 32, 33, 52, 13, 44, 32],
  //     },
  // ];

  return (
    <>
      {/*<h4 className="header-title mb-3">{title}</h4>*/}

      <Chart
        options={apexBarChartOpts}
        series={datasets}
        type="bar"
        className="apex-charts"
        height={400}
      />
    </>
  );
};

export default React.memo(BarChart);
